<template>
  <b-card class="p-0 m-0" header="Biometrics">
    <div class="spnod-admin__account--section">
      <ul>
        <li class="spnod-admin__form--list pb-2" v-for="question in questions">
          <b-row class="mx-0">{{ question.question }}</b-row>
          <b-row class="mx-0"><span class="text-muted">{{ question.answer ? question.answer : 'N/A' }}</span></b-row>
        </li>
      </ul>
    </div>
    <b-button v-if="!forClient" class="spnod-admin__form--button" size="sm" @click="$emit('toggleBiometrics')">Edit</b-button>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BiometricsList',
  props: ['forClient', 'user'],
  computed: {
    ...mapGetters(['getMyInfo', 'biometricsSchema', 'getClientInfo']),
    questions() {
      return this.biometricsSchema.map(s => {
        let answer = this.user.biometrics ? this.user.biometrics[s.name] : null
        return { question: s.placeholder, answer }
      })
    }
  },
  methods: {
    ...mapActions(['loadBiometrics'])
  },
  mounted: async function() {
    if (!this.biometricsSchema.length) await this.loadBiometrics()
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Biometrics/BiometricsList.vue?0d842faf